module.exports = __webpack_public_path__ + "static/showroom2-3f04b0fc6b0c230a25a3188736a26492.jpg";